<template>
  <div class="inner_wrap">
    <ul class="select_wrap">
      <li @click="scrollToSection('.content1')">
        도전! <br />
        대학교 대항전
      </li>
      <li @click="scrollToSection('.content2')">실시간 랭킹</li>
      <li @click="scrollToSection('.content3')">참여 방법</li>
    </ul>
    <section class="content1">
      <div class="con1_txt">
        <img
          src="@/assets/images/event/2025-1-competition/content1_1.png"
          alt="대학교 대항전"
        />
      </div>
      <div class="">
        <img
          src="@/assets/images/event/2025-1-competition/content1_2.png"
          alt=""
        />
      </div>
      <div class="inner">
        <div class="explain">
          <img
            src="@/assets/images/event/2025-1-competition/content1_3.png"
            alt=""
          />
        </div>
      </div>
    </section>
    <section ref="counterContainer" class="content2">
      <div class="lapping">
        <img
          src="@/assets/images/event/2025-1-competition/content2_1.png"
          alt=""
        />
        <div class="count_user_box">
          <div
            v-if="isEventOpen && getCurrentUser && getCurrentUser.unicolNm"
            class="my_collage_wrap"
          >
            <span class="txt"> {{ getCurrentUser.unicolNm }} </span>는
            <span
              class="score counter my_score"
              :data-target="
                getEventUserUnivInfo.totalPoint
                  ? getEventUserUnivInfo.totalPoint
                  : '-'
              "
            ></span>
            점 입니다.
          </div>
          <ul
            :class="[
              isEventOpen && getCurrentUser && getCurrentUser.unicolNm
                ? 'active'
                : ''
            ]"
            class="couter_wrap"
          >
            <li v-for="(score, i) in getEventRanklist" :key="i">
              <i>{{ score.rank }}위</i>
              <span class="collage">{{ score.universityName }}</span>
              <span
                class="score counter"
                :data-target="score.totalPoint"
              ></span>
              점
            </li>
          </ul>
          <div class="user_check">
            <!-- 이벤트 오픈 전: non_event 보여줌 -->
            <div v-if="!isEventOpen" class="non_event">
              <span class="txt">
                이벤트 <br />
                준비중 입니다!
              </span>
              <span class="apply">
                2월 24일 오픈
              </span>
            </div>

            <!-- 이벤트 오픈 후 & 로그인 안 한 경우: non_member 보여줌 -->
            <div v-else-if="!getCurrentUser" class="non_member">
              <span class="txt">
                로그인 하시고 <br />
                우리학교 순위를 <br />
                확인해 보세요!
              </span>
              <router-link class="apply" to="/login">
                로그인 하기
              </router-link>
            </div>

            <!-- 이벤트 오픈 후 & 로그인 했으나 학교정보 없는 경우: non_collage 보여줌 -->
            <div v-else-if="!getCurrentUser.unicolNm" class="non_collage">
              <span class="txt">
                학교 입력을 하신 후 <br />
                우리학교 순위를 <br />
                확인해 보세요!
              </span>
              <span class="apply" @click="toggleCollegePutModal">
                학교입력 하기
              </span>
            </div>
          </div>
          <p class="info">
            ※랭킹 순위는 매일 4시간마다 자동 업데이트 됩니다. <br />
            <span>
              (동점 학교가 발생할 경우, 먼저 해당 점수를 달성한 학교가
              우선순위로 높은 순위를 차지합니다.)
            </span>
          </p>
        </div>
      </div>
    </section>
    <section class="content3">
      <div class="inner">
        <div class="cont3_txt">
          <img
            src="@/assets/images/event/2025-1-competition/content3_1.png"
            alt=""
          />
          <div>
            <span>25년도 신학기!</span>
            <p>
              캠퍼스북으로 교재도 저렴하게 구매 하고 <br />
              동기들 초대해서 경품도 받자! <span>(소장, 대여 모두 가능)</span>
            </p>
          </div>
        </div>
        <ul>
          <li>
            <div class="step01">
              <img
                src="@/assets/images/event/2025-1-competition/content3_2.png"
                alt=""
              />
            </div>
            <div>
              <img
                src="@/assets/images/event/2025-1-competition/content3_3.png"
                alt=""
              />
            </div>
            <span class="or">또는</span>
            <div class="member_mt">
              <img
                src="@/assets/images/event/2025-1-competition/content3_5.png"
                alt=""
              />
            </div>
            <!-- 회원가입 하러가기 -->
            <router-link v-if="!getCurrentUser" class="join_go" to="/login">
              <img
                src="@/assets/images/event/2025-1-competition/content3_6.png"
                alt=""
              />
            </router-link>
          </li>
          <li>
            <div class="step02">
              <img
                src="@/assets/images/event/2025-1-competition/content3_4.png"
                alt=""
              />
            </div>
            <div>
              <img
                src="@/assets/images/event/2025-1-competition/content3_7.png"
                alt=""
              />
            </div>
            <!-- 도서 보러 가기 -->
            <router-link class="book_go" to="/store/A/books/A">
              <img
                src="@/assets/images/event/2025-1-competition/content3_8.png"
                alt=""
              />
            </router-link>
          </li>
        </ul>
      </div>
    </section>
    <section class="content4">
      <div class="inner">
        <div class="cont4_txt">
          <img
            src="@/assets/images/event/2025-1-competition/content4_1.png"
            alt=""
          />
        </div>
        <ul class="benefit_list">
          <li class="first_wrap">
            <div class="first">
              <img
                src="@/assets/images/event/2025-1-competition/competition_benefit1.png"
                alt=""
              />
            </div>
            <span>1등 대학교 이벤트 응모 학생 전원 아메리카노 증정!</span>
            <div>
              <img
                src="@/assets/images/event/2025-1-competition/content4_2.png"
                alt=""
              />
            </div>
          </li>
          <li class="second_wrap">
            <div class="second">
              <img
                src="@/assets/images/event/2025-1-competition/competition_benefit2.png"
                alt=""
              />
            </div>
            <span>응모자 추첨 기프티콘 지급</span>
            <div>
              <img
                src="@/assets/images/event/2025-1-competition/content4_3.png"
                alt=""
              />
            </div>
          </li>
          <li class="third_wrap">
            <div class="third">
              <img
                src="@/assets/images/event/2025-1-competition/competition_benefit3.png"
                alt=""
              />
            </div>
            <span>응모자 추첨 기프티콘 지급</span>
            <div>
              <img
                src="@/assets/images/event/2025-1-competition/content4_4.png"
                alt=""
              />
            </div>
          </li>
          <li class="fourth_wrap">
            <div class="fourth">
              <img
                src="@/assets/images/event/2025-1-competition/competition_benefit4.png"
                alt=""
              />
            </div>
            <span>응모자 추첨 기프티콘 지급</span>
            <div class="beneforth">
              <img
                src="@/assets/images/event/2025-1-competition/content4_5.png"
                alt=""
              />
            </div>
          </li>
        </ul>
      </div>
      <div
        class="caution_wrap user_cause"
        style="background: transparent;"
        @click="toggleCaution(1)"
      >
        <button class="yellow mt3">유의사항 보기</button>
        <div v-show="cautionStates[1]" class="slide_list">
          <div class="point_save">이벤트 공통사항</div>
          <div class="cau_wrap1">
            <ul>
              <li>
                · 사은품 발송 및 경품 추첨 예정일 : 25년 4월 7일 경
              </li>
              <li>
                · 사은품 발송 시점에 가입 후 탈퇴하시거나 수정, 구매/대여 환불
                시 상품권 증정 대상에서 제외됩니다.
              </li>
              <li>
                · 사은품은 추첨일 기준으로 지급되며, 사은품은 당사사정에 의해
                예고없이 변경 될 수 있습니다.
              </li>
              <li>
                · 추첨 혜택은 캠퍼스북 가입자 이벤트 참여 대상자를 통해 추첨을
                진행합니다.
              </li>
              <li>
                · 이용중인 휴대폰에 스팸 설정이 되어 있는 경우, 경품 대행사의
                당첨 및 배송안내 연락을 받지 못할 수 있습니다.
              </li>
              <li>
                · 이벤트의 중복 당첨은 불가합니다.
              </li>
              <li>
                · 당첨자 선정은 랜덤으로 이루어지며, 발표 이후 선정 기준에 따른
                답변 및 응대를 제공하지 않음을 양해바랍니다.
              </li>
              <li>
                · 이벤트 참여를 위해 개인 정보 취급에 동의하여 주시기 바랍니다.
                입력해주신 정보는 경품 발송 등 경품관련 확인을 위해서
                이용됩니다.
              </li>
              <li>
                · 이벤트 경품은 타인에게 양도 및 판매 불가능하며, 타 상품으로
                교환 및 환불이 불가능합니다.
              </li>
              <li>
                · 잘못 입력된 고객 정보로 인한 당첨 취소는 당사에서 책임지지
                않습니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="content5">
      <div>친구에게 공유하고 함께 이벤트 참여하세요!</div>
      <ul class="share_wrap">
        <!-- <li>
              <img
                src="@/assets/images/event/2025-1-competition/event_kakao.png"
                alt=""
              />
              카카오톡 공유
            </li> -->
        <li
          @click="copyToClipboard"
          class="copy_button"
          :class="{ 'copied': isCopied }"
        >
          <img
            src="@/assets/images/event/2025-1-competition/event_share.png"
            alt=""
          />
          링크 복사하기
          <div class="tooltip" v-if="showTooltip">링크 복사 되었습니다.</div>
        </li>
      </ul>
    </section>
    <router-link class="inner campusbook_go" to="/">
      <img
        src="@/assets/images/event/2025-1-competition/campusbook_go.png"
        alt=""
      />
    </router-link>

    <div class="caution_wrap" @click="toggleCaution(0)">
      <span class="txt" :class="{ 'active': cautionStates[0] }">
        대학교 대항전 이벤트 유의사항
      </span>
      <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
        <div v-show="cautionStates[0]" class="slide_list">
          <div class="point_save">[포인트 적립 방법]</div>
          <div class="cau_wrap1">
            <ul>
              <li>
                · 학교 대항전의 포인트 제도는, 위 이벤트 에서만 사용 되며,
                이벤트 종료 즉시 소멸될 예정 입니다.
              </li>
              <li>
                · 포인트를 쌓는 방법에는 총 3가지가 있으며, 이는 아래와
                같습니다.
              </li>
            </ul>

            <dl>
              <dt>a. 2025.02.24 이전 회원가입</dt>
              <dd class="depth1">
                I. 2025.02.23 23시59분 기준 회원 정보 상 등록 되어있는 학교로
                포인트가 적립 됩니다.
              </dd>
              <dd class="depth1">
                II. 이벤트 시작 이후 등록 학교를 변경 하더라도 추가 포인트는
                적립되지 않습니다.
              </dd>
              <dt>
                b. 2025.02.24 이후 신규 회원가입 및 회원가입 시 학교 정보 입력
              </dt>
              <dd class="depth1">
                I. 2025.02.24 00시 00분 이후 신규 회원가입 및 회원가입 시 학교
                정보를 입력한 회원에 한해, 등록한 학교로 포인트가 적립 됩니다.
              </dd>
              <dt>c. 학교 정보 등록 후 도서 구매</dt>
              <dd class="depth1">
                I. 도서를 구매한 시점에, 회원정보에 등록되어있는 학교로 포인트가
                적립됩니다. 1. 2025.02.27일 등록된 학교 고연대 -> 연고대로 변경.
                2025.02.28 “심리학개론” 도서 구매 -> 연고대학교로 도서 구매
                포인트 적립,
              </dd>
              <dd class="depth1">
                II. 도서 가격에 따라 적립되는 포인트가 상이할 수 있습니다.
              </dd>
              <dd class="depth1">
                III. 도서 구매 후 환불 시, 적립되었던 포인트가 차감됩니다.
              </dd>
            </dl>
            <p>
              *등록한 학교 정보는 입력 시 부터 1달간 변경이 불가능 합니다.
            </p>

            <h2>경품 유의사항</h2>
            <dl>
              <dt>[네이버페이 포인트 쿠폰]</dt>
              <dd>
                · 본 경품은 전환 쿠폰으로 지급 예정이며 해당 쿠폰의 유효기간 내
                미 사용 시 자동 만료 처리됩니다. <br />
                (기간 내 미 사용으로 인한 불이익은 당사가 책임지지 않습니다.)
              </dd>
              <dd>
                · 본 쿠폰은 당첨자의 회원정보에 등록되어있는 휴대폰 번호로 자동
                발송 예정입니다.
              </dd>
              <dt>
                · 네이버페이 포인트의 유효기간은 적립 일로부터 10년이며 쿠폰
                등록 방법은 아래와 같습니다.
              </dt>
              <dd>- 네이버페이 홈 (pay.naver.com) 접속</dd>
              <dd>
                - 네이버 ID와 패스워드로 로그인(네이버페이 이용약관 동의 필수)
              </dd>
              <dd>
                - PC : 네이버페이 홈 > 혜택·쿠폰 > 쿠폰 > 쿠폰 등록 > 쿠폰번호
                입력
              </dd>
              <dd>
                - MO : 네이버페이 홈 > 페이 서비스(우측 상단 삼선 버튼) > 쿠폰 >
                쿠폰 등록 > 쿠폰번호 입력
              </dd>
              <dd>
                · 네이버페이 포인트는 1인 당 최대 200만원까지 보유하실 수
                있습니다.
              </dd>
              <dd>
                · 네이버페이 포인트 쿠폰이 정상적으로 등록된 경우 네이버페이 >
                포인트 메뉴에서 내역을 확인하실 수 있습니다. (반영에 최대 1분이
                소요됩니다.)
              </dd>
              <dd>
                · 네이버페이 포인트 쿠폰으로 등록된 금액은 적립 포인트로
                지급되며 취소 및 현금 인출이 불가합니다.
              </dd>
              <dd>
                · 네이버페이 포인트는 네이버 쇼핑/네이버 웹툰/네이버 예약을
                비롯한 45만개 이상 가맹점에서 현금처럼 이용하실 수 있습니다.
              </dd>
              <dd>
                · 일부 페이 가맹점에서는 포인트 사용이 제한될 수 있습니다.
              </dd>
              <dd>· 쿠폰 등록 오류 문의 : 네이버페이 고객센터 1588-3819</dd>

              <dt class="space">
                [메가MGC커피 (HOT) 아메리카노 모바일 교환권]
              </dt>
              <dd>
                · 본 교환권의 유효기간은 지급일로부터 30일까지로 기간 내 미사용
                시 자동 만료 처리됩니다. <br />(기간 내 미사용으로 인한 불이익은
                당사가 책임지지 않습니다.)
              </dd>
              <dd>
                · 전국 메가MGC커피 매장에서 사용 가능합니다. (일부매장 제외)
              </dd>
              <dd>
                · 본 상품 교환시 메가커피 스탬프 및 포인트 적립은 브랜드사
                정책에 따릅니다.
              </dd>
              <dd>
                · 브랜드사 정책은 메가커피앱 - 스탬프 - 스탬프 카드 적립
                유의사항 안내에서 확인 가능합니다.
              </dd>
              <dd>
                · 본 상품은 매장 내 재고가 없을 경우 동일 가격 이상의 다른
                상품으로 교환이 가능하며 차액은 추가 지불하여야 합니다.
              </dd>
              <dd>
                · 사용 불가 매장 : 건대 학생회관점, 동소문점, 강남역점,
                여의도파크원점, 홈플러스 안산선부점, 안양1번가점,
                의정부망월사점, 용인성복역점, 천안터미널점, 홈플러스 울산점,
                김해롯데워터파크점
              </dd>
              <dd>· 경품 관련 문의 : 기프티쇼(1588-6474)</dd>

              <dt class="space">[BHC 후라이드 + 콜라 1.25L]</dt>
              <dd>
                · 본 교환권의 유효기간은 지급일로부터 30일까지로 기간 내 미사용
                시 자동 만료 처리됩니다.(기간 내 미사용으로 인한 불이익은 당사가
                책임지지 않습니다.)
              </dd>
              <dd>
                · BHC 앱 [E교환권주문]&BHC홈페이지[온라인주문]을 통해 사용
                가능합니다. (일부매장 제외)
              </dd>
              <dd>
                · 매장(홀)취식 사용 시 일부 및 특수매장은 매장 판매가 기준으로
                제공되며 추가금이 발생할 수 있습니다.
              </dd>
              <dd>
                · 본 상품은 매장 상황 및 거리에 따라 배달 불가 및 배달료가
                발생할 수 있으며 지역에 따라 배달료가 상이할 수 있습니다.
              </dd>
              <dd>
                · 쿠폰에 명시되어있는 상품으로만 교환 가능합니다(타제품
                교환불가)
              </dd>
              <dd>· 경품 관련 문의 : 기프티쇼(1588-6474)</dd>
            </dl>
          </div>
        </div>
      </transition>
      <!-- 학교등록하기 -->
      <transition v-on-clickaway="toggleCollegePutModal" name="modal-fade">
        <Modal v-if="showCollegePutModal" @close="toggleCollegePutModal">
          <div class="ly_pop_wrap college_put">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <a class="btn_ly_close svg_close" @click="toggleCollegePutModal"
                  ><span>{{ $t('library.deletemodal.close') }}</span></a
                >
              </div>
              <div class="ly_inner cart_alert_wrap">
                <div class="cell">
                  <div class="cart_desc_wrap">
                    <div class="cart_desc_head">
                      <span class="star">*</span> 고객님의 <br />
                      <span class="line_bottom">학교를 선택해 주세요.</span>
                    </div>
                    <div class="cart_desc_body">
                      <div class="put_wrap">
                        <input
                          id="unicol"
                          v-model="unicolNm"
                          class="input_t put_college"
                          name="unicol"
                          placeholder="학교를 선택해 주세요"
                          readonly="readonly"
                          @click="toggleUnicolModal"
                        />
                        <button
                          class="college_search"
                          @click="toggleUnicolModal"
                        >
                          검색
                        </button>
                      </div>
                      <p class="because">
                        ※마케팅 정보 수신 동의는 계정 설정을 통해 언제든지
                        변경(동의/철회) 하실 수 있습니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="btn_wrap">
                  <button class="box_btn dull" @click="updateCollege">
                    확인
                  </button>
                </div>
              </div>
              <unicolModal
                v-if="isShowUnicol"
                @close="toggleUnicolModal"
                @unicolInfo="selectUnicol"
              />
            </div>
          </div>
        </Modal>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import unicolModal from '@/components/library/unicolModal.vue'
import {
  ACCOUNT_UPDATE_UNICOL,
  AUTH_REFRESH,
  FETCH_EVENT_POINT_RANK,
  FETCH_EVENT_POINT_UNIVERSITY
} from '@/store/types'
export default {
  name: 'Competition2025-1',
  components: {
    unicolModal
  },
  data() {
    return {
      cautionStates: [false, false],
      isCounting: false,
      observer: null,
      showCollegePutModal: false,
      isShowUnicol: false,
      unicolCd: '',
      unicolNm: '',
      nonCollege: false,
      isCopied: false,
      showTooltip: false,
      tooltipTimeout: null,
      rankList: [],
      userUnivInfo: null,
      eventId: 'EVENT_2025_01'
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentUser',
      'getEventRanklist',
      'getEventUserUnivInfo'
    ]),
    isEventOpen() {
      const today = new Date()
      const eventDate = new Date('2025-02-23')
      return today >= eventDate
    }
  },
  watch: {
    getCurrentUser: {
      handler(newValue) {
        this.fetchEventPointUniversity(this.eventId, newValue?.unicolCd)
        // 여기서 필요한 로직 수행
      },
      deep: true
    }
  },
  mounted() {
    // Intersection Observer를 사용하여 스크롤 이벤트 대체
    this.setupIntersectionObserver()

    this.fetchEventPointRank(this.eventId)

    if (this.getCurrentUser) {
      this.fetchEventPointUniversity(
        this.eventId,
        this.getCurrentUser?.unicolCd
      )
    }
    // 기존 window 스크롤 이벤트 리스너 방식도 남겨둠
    // this.setupScrollListener();
  },
  beforeDestroy() {
    // 컴포넌트 제거 시 observer 정리
    if (this.observer) {
      this.observer.disconnect()
    }
    // 컴포넌트 제거 시 남아있는 타임아웃 정리
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout)
    }

    // 스크롤 이벤트 리스너 사용 시 정리
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async fetchEventPointRank(eventId) {
      await this.$store.dispatch(FETCH_EVENT_POINT_RANK, eventId)
    },
    async fetchEventPointUniversity(eventId, univCode) {
      await this.$store.dispatch(FETCH_EVENT_POINT_UNIVERSITY, {
        eventId: eventId,
        univCode: univCode
      })
    },
    copyToClipboard() {
      // 현재 URL 가져오기
      const currentUrl = window.location.href

      // 복사를 위한 임시 textarea 요소 생성
      const textarea = document.createElement('textarea')
      textarea.value = currentUrl
      textarea.style.position = 'fixed' // 하단으로 스크롤 방지
      document.body.appendChild(textarea)
      textarea.select()

      try {
        // 복사 명령 실행
        const successful = document.execCommand('copy')
        if (successful) {
          this.showCopiedFeedback()
        } else {
          console.error('복사 명령이 실패했습니다')
        }
      } catch (err) {
        console.error('복사 작업 중 오류 발생:', err)
      }

      // 정리 작업
      document.body.removeChild(textarea)
    },
    showCopiedFeedback() {
      // 시각적 피드백을 위한 상태 설정
      this.isCopied = true
      this.showTooltip = true

      // 기존 타임아웃 제거
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
      }

      // 일정 시간 후 상태 초기화
      this.tooltipTimeout = setTimeout(() => {
        this.isCopied = false
        this.showTooltip = false
      }, 2000)
    },

    toggleUnicolModal() {
      this.isShowUnicol = !this.isShowUnicol
    },
    toggleCollegePutModal() {
      if (this.getCurrentUser === null) {
        this.$router.push({ name: 'login' })
      } else {
        this.showCollegePutModal = !this.showCollegePutModal
      }
    },
    selectUnicol(school) {
      if (!school) {
        this.toggleUnicolModal()
        return
      }
      this.toggleUnicolModal()
      this.unicolNm = school.unicolNm
      this.unicolCd = school.unicolCd
    },
    async updateCollege() {
      if (!this.unicolNm) {
        alert('학교를 선택해주세요.')
        return
      }
      try {
        await this.$store.dispatch(ACCOUNT_UPDATE_UNICOL, {
          unicolCode: this.unicolCd
        })
        await this.$store.dispatch(AUTH_REFRESH)
      } catch (err) {
        alert('오류가 발생했습니다.')
      } finally {
        this.showCollegePutModal = false // 모달 닫기
      }
    },
    setupIntersectionObserver() {
      const options = {
        root: null, // viewport 기준
        rootMargin: '0px',
        threshold: 0.1 // 10% 이상 보일 때 콜백 실행
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.isCounting) {
              this.startCounting()
            }
          } else {
            this.resetCounters()
          }
        })
      }, options)

      this.observer.observe(this.$refs.counterContainer)
    },
    // 기존 스크롤 이벤트 로직을 Vue 방식으로 변환
    setupScrollListener() {
      window.addEventListener('scroll', this.handleScroll)
    },

    handleScroll() {
      const containerEl = this.$refs.counterContainer
      const containerTop = containerEl.offsetTop
      const containerHeight = containerEl.offsetHeight

      if (
        window.pageYOffset > containerTop - window.innerHeight &&
        window.pageYOffset < containerTop + containerHeight
      ) {
        if (!this.isCounting) {
          this.startCounting()
        }
      } else {
        this.resetCounters()
      }
    },
    startCounting() {
      const counters = this.$el.querySelectorAll('.counter')
      const speed = 500

      counters.forEach((counter) => {
        const updateCount = () => {
          const target = +counter.dataset.target
          const count = +counter.innerText.replace(/,/g, '')
          const inc = target / speed

          if (count < target) {
            counter.innerText = Math.ceil(count + inc).toLocaleString()
            setTimeout(updateCount, 1)
          } else {
            counter.innerText = target.toLocaleString()
          }
        }

        updateCount()
      })

      this.isCounting = true
    },

    resetCounters() {
      const counters = this.$el.querySelectorAll('.counter')
      counters.forEach((counter) => {
        counter.innerText = '0'
      })
      this.isCounting = false
    },
    toggleCaution(index) {
      this.$set(this.cautionStates, index, !this.cautionStates[index])
    },
    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },
    enter(el) {
      const height = el.scrollHeight
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = `${height}px`
      el.style.opacity = '1'
    },
    leave(el) {
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = '0'
      el.style.opacity = '0'
    },
    scrollToSection(targetSelector) {
      const targetElement = document.querySelector(targetSelector)

      if (targetElement) {
        // 요소의 위치와 계산된 스타일 가져오기
        const elementRect = targetElement.getBoundingClientRect()
        const computedStyle = window.getComputedStyle(targetElement)

        // 패딩 및 마진 계산
        const marginTop = parseInt(computedStyle.marginTop)
        const paddingTop = parseInt(computedStyle.paddingTop)

        // 요소의 절대 위치 계산
        const absoluteElementTop = elementRect.top + window.pageYOffset

        // 최종 오프셋 계산 (패딩 및 마진 포함)
        let finalOffset = absoluteElementTop - marginTop - paddingTop

        if (window.innerWidth <= 1022) {
          finalOffset -= 60 // 60px 추가 오프셋
        } else if (window.innerWidth <= 768) {
          finalOffset -= 12
        } else if (window.innerWidth <= 480) {
          finalOffset -= 12
        } else {
          finalOffset -= 120
        }
        window.scrollTo({
          top: finalOffset,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// apply
.tooltip {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 10;
  animation: fadeIn 0.3s ease-in-out;
  &::after {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0 6px 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.8) transparent;
  }
}
body {
  overflow-y: hidden;
}
.inner {
  max-width: 790px;
  margin: 0 auto;
}
.space {
  margin: 50px 0 5px;
}
.depth1 {
  padding-left: 20px;
}
.depth2 {
  padding-left: 25px;
}
.depth3 {
  padding-left: 30px;
}
img {
  width: 100%;
  height: 100%;
}
main {
  width: 100%;
  margin-bottom: 100px;
}
section {
  position: relative;
  width: 100%;
}
.lapping {
  position: relative;
}
.inner_wrap {
  max-width: 1120px;
  margin: 0 auto;
  text-align: center;
  background: #201756;
}
.yellow {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 30px;
  line-height: 32px;
  color: #fff;
  &.mt1 {
    margin-top: 30px;
  }
  &.mt3 {
    margin-top: 35px;
  }
  &::after {
    content: '';
    display: block;
    background: url('../../../assets/images/event/2025-1-competition/arrow.png')
      no-repeat center center;
    background-size: contain;
    width: 63px;
    height: 45px;
  }
}
.caution_wrap {
  padding: 100px 100px 65px;
  background-color: #353535;
  user-select: none;
  cursor: pointer;
  &.user_cause {
    padding: 0;
  }
  .txt {
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    font-family: 'pretendard-light';
    font-size: 45px;
    line-height: 45px;
    color: #fff;
    &::after {
      content: '';
      display: block;
      background: url('../../../assets/images/event/2025-1-competition/arrow.png')
        no-repeat center center;
      background-size: contain;
      width: 56px;
      height: 27px;
      transform: rotate(-180deg);
    }
    &.active {
      &::after {
        transform: rotate(0);
      }
    }
  }
  .slide_list {
    // width: 600px;
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    list-style-type: disc;
    font-size: 22px;
    color: #fff;
    .point_save {
      margin-bottom: 10px;
    }
    li {
    }
    .cau_wrap1 {
      line-height: 43px;
      ul {
        li {
          line-height: 43px;
        }
      }
      h2 {
        font-size: 45px;
        margin: 50px 0 40px;
      }
      p {
      }
    }
  }
}
.select_wrap {
  display: flex;
  li {
    flex: 1;
    padding: 23px 0;
    background-color: #d8d8d8;
    border-right: 1px solid #ffffff;
    text-transform: uppercase;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 26px;
    color: #201756;
    cursor: pointer;
    &:nth-child(2) {
      padding: 42px 0 0;
    }
    &:last-child {
      border-right: none;
      padding: 42px 0 0;
    }
  }
}
// cont
.content1 {
  padding-bottom: 65px;

  img {
    display: block;
  }
  .txt_wrap {
    position: absolute;
    top: 100px;
    left: 100px;
    text-align: left;
    h2 {
      margin-bottom: 33px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 80px;
      line-height: 84px;
      color: #5c61dd;
    }
    span {
      font-size: 40px;
      line-height: 49px;
      color: #000000;
      b {
        font-family: 'pretendard-medium';
        font-weight: 600;
      }
    }
  }
}
.content2 {
  position: relative;
  // height: 202vh;
  height: 1900px;
  .my_collage_wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    font-family: 'pretendard-medium';
    font-size: 38px;
    color: #f7d608;
    .txt {
      // margin-right: 20px;
    }
    .my_score {
      flex: 0.62;
      text-align: right;
    }
  }
  .count_user_box {
    position: absolute;
    top: 31%;
    left: 50%;
    transform: translateX(-50%);
    .user_check {
      // display: none;
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translateX(-50%);
      background-color: #e4e3ea;
      width: 680px;
      border-radius: 20px;
      .non_event {
        padding: 55px 63px 25px;
        .apply {
          cursor: auto;
        }
      }
      .non_member {
        padding: 55px 63px 25px;
      }
      .non_collage {
        padding: 55px 63px 25px;
      }
      .txt {
        display: block;
        margin-bottom: 50px;
        font-family: 'pretendard-medium';
        font-weight: 600;
        font-size: 45px;
        line-height: 53px;
        color: #201756;
      }
      .apply {
        display: block;
        width: 360px;
        margin: 0 auto;
        padding: 20px 14px;
        font-family: 'pretendard-medium';
        font-weight: 600;
        font-size: 52px;
        line-height: 44px;
        border-radius: 40px;
        background: #51499b;
        cursor: pointer;
        color: #f7d608;
      }
    }
    .info {
      margin-top: 24px;
      font-family: 'pretendard-medium';
      font-size: 30px;
      color: #ffea61;
      span {
        font-size: 22px;
      }
    }
  }
  .couter_wrap {
    // transform: translateX(-50%) translateY(-50%);
    // max-width: 790px;
    width: 790px;
    padding: 40px 40px;
    background-color: #544d7d;
    border-radius: 20px;
    filter: blur(10px);
    -webkit-filter: blur(10px);
    &.active {
      filter: blur(0);
      -webkit-filter: blur(0);
    }
    li {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      padding: 23px 0;
      border-bottom: 1px solid #fff;
      font-size: 35px;
      color: #fff;
      &:first-child {
        color: #ffea61;
        i {
          background: url('../../../assets/images/event/2025-1-competition/first.png')
            no-repeat center center;
          background-size: contain;
          height: 75px;
          text-indent: -9999px;
        }
      }
      &:nth-child(2) {
        i {
          background: url('../../../assets/images/event/2025-1-competition/second.png')
            no-repeat center center;
          background-size: contain;
          height: 75px;
          text-indent: -9999px;
        }
      }
      &:nth-child(3) {
        i {
          background: url('../../../assets/images/event/2025-1-competition/third.png')
            no-repeat center center;
          background-size: contain;
          height: 75px;
          text-indent: -9999px;
        }
      }
      &:nth-child(n + 4) {
        .collage {
          font-size: 37px;
          line-height: 37px;
        }
      }
      &:last-child {
        border-bottom: none;
      }
      i {
        width: 88px;
        margin-right: 25px;
        font-size: 47px;
      }
      .collage {
        flex-grow: 1;
        font-family: 'pretendard-medium';
        font-size: 50px;
        line-height: 50px;
        text-align: left;
      }
      .score {
        font-size: 35px;
        line-height: 35px;
        text-align: right;
      }
    }
  }
}
.content3 {
  padding: 0 0;
  .cont3_txt {
    div {
      margin-top: 40px;
      font-family: 'pretendard-medium';
      font-size: 50px;
      color: #ffea61;
      p {
        font-family: 'pretendard-medium';
        span {
          display: block;
          margin-top: 10px;
          font-size: 40px;
          line-height: 40px;
          color: #f9f9f9;
        }
      }
    }
  }
  .step01,
  .step02 {
    width: 269px;
  }
  .step01 {
    margin: 70px 0 25px;
  }
  .step02 {
    margin-top: 60px;
    margin-bottom: 25px;
  }
  .or {
    display: block;
    margin: 35px 0 35px;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 38px;
    line-height: 38px;
    color: #ffff;
  }
  .member_mt {
    margin-bottom: 50px;
  }
  .join_go {
    display: block;
    width: 490px;
    margin: 0 auto;
  }
  .book_go {
    display: block;
    width: 490px;
    margin: 50px auto 50px;
  }
}
.content4 {
  position: relative;
  z-index: 1;
  // height: 360vh;
  padding: 150px 0 90px;
  text-align: center;
  &::after {
    content: '';
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    background: url('../../../assets/images/event/2025-1-competition/content4_back.png')
      no-repeat;
    background-size: contain;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .cont4_txt {
    img {
      width: 411px;
    }
  }
  .benefit_list {
    .first,
    .second,
    .third {
      margin-top: 60px;
      img {
        width: 97px;
      }
    }
    .fourth {
      margin-top: 60px;
      img {
        width: 208px;
      }
    }
    .second_wrap,
    .third_wrap,
    .fourth_wrap {
      span {
        font-weight: normal;
      }
    }
    span {
      display: block;
      margin: 32px 0 20px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 32px;
      line-height: 32px;
      color: #ffea61;
    }
    .beneforth {
      img {
        width: 523px;
      }
    }
  }
  .user_cause {
    .slide_list {
      width: 820px;
    }
  }
}
.content5 {
  padding: 40px 0 45px 0;
  background: #fff;
  > div {
    margin-bottom: 25px;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 38px;
    letter-spacing: 0.2px;
  }
  .share_wrap {
    display: flex;
    justify-content: center;
    gap: 80px;
    li {
      display: flex;
      flex-direction: column;
      font-size: 24px;
      cursor: pointer;
      img {
        width: 169px;
      }
    }
  }
}
.campusbook_go {
  display: block;
  width: 585px;
  padding: 75px 0;
}
// 학교정보 얼럿창
.college_put {
  .ly_pop_msg {
    width: 320px !important;
    background-color: #fff;
    .ly_inner {
      padding: 20px 25px 15px 25px;
      .cell {
        display: block;
        width: auto;
        height: auto;
        padding-bottom: 0;
        .cart_desc_head {
          margin-bottom: 10px;
          font-weight: 600;
          color: #000000;
          font-size: 16px;
          text-align: left;
          .star {
            font-size: 11px;
            color: #fc2769;
          }
          .line_bottom {
            padding-left: 8px;
          }
        }
        .cart_desc_body {
          .put_wrap {
            position: relative;
            .put_college {
              width: 100%;
              height: 43px;
              padding-left: 15px;
              border: 1px solid #787a7d;
              border-radius: 8px;
              &::placeholder {
                color: #bfbfbf;
              }
            }
            .college_search {
              position: absolute;
              top: 50%;
              right: 10px;
              transform: translateY(-50%);
              padding: 2px 10px;
              background-color: #b5b5b5;
              border-radius: 5px;
              color: #fff;
              font-size: 13px;
            }
          }
          .because {
            margin-top: 5px;
            text-align: left;
            font-size: 11px;
            color: #454545;
          }
        }
      }
      .btn_wrap {
        margin-top: 8px;
        .box_btn {
          width: 50px;
          height: 23px;
          border-radius: 5px;
          background-color: #39a5c1;
          font-size: 13px;
          color: #fff;
          padding: 0;
        }
      }
    }
  }
}
.box_btn {
  width: 50px;
  height: 23px;
  border-radius: 5px;
  background-color: #39a5c1;
  font-size: 13px;
  color: #fff;
  padding: 0;
  border: none;
  margin-top: 13px;
}
@media (max-width: 960px) {
  .content2 {
    height: 1665px;
  }
  .content2 .couter_wrap li .collage {
    font-size: 44px;
    line-height: 44px;
  }
  .content2 .couter_wrap li i {
    width: 70px;
    font-size: 37px;
  }
  .content2 .couter_wrap li:first-child i {
    height: 60px;
  }
  .content2 .couter_wrap li:nth-child(2) i {
    height: 60px;
  }
  .content2 .couter_wrap li:nth-child(3) i {
    height: 60px;
  }
  .content2 .couter_wrap li .score {
    font-size: 32px;
    line-height: 32px;
  }
  .content2 .couter_wrap li {
    padding: 14px 0;
  }
  .content2 .existing_member .sub_topic {
    &::before {
      left: 20px;
      width: 100px;
      height: 100px;
    }
  }
  .content2 .new_member .sub_topic {
    &::after {
      right: 20px;
      width: 100px;
      height: 100px;
    }
  }
  .content3 .main_topic {
    &::before {
      left: 10px;
    }
  }
  .content3 .sub_topic {
    &::after {
      right: 10px;
    }
  }
  .content3 .price {
    &::before {
      left: 0;
    }
  }
  .content3 .bottom_txt {
    &::after {
      right: 0;
    }
  }
}
@media (max-width: 768px) {
  //apply
  .yellow {
    font-size: 23px;
    line-height: 23px;
    &::after {
      width: 54px;
    }
  }
  .inner {
    max-width: 500px;
  }
  .caution_wrap {
    padding: 45px 0 5px;
    &.user_cause {
      .slide_list {
        width: 590px;
      }
    }
    .txt {
      padding-left: 107px;
      font-size: 28px;
      line-height: 28px;
      letter-spacing: 1px;
    }
    .slide_list {
      width: 460px;
      li {
        font-size: 21px;
      }
    }
  }
  .select_wrap {
    li {
      padding: 23px 0;
      font-size: 21px;
    }
  }
  // cont
  .content1 {
    .txt_wrap {
      top: 40px;
      left: 30px;
      h2 {
        font-size: 60px;
        line-height: 63px;
        margin-bottom: 20px;
      }
      span {
        font-size: 25px;
        line-height: 31px;
      }
    }
  }
  .content2 {
    // height: 150vh;
    height: 1465px;
    padding-top: 60px;
    padding-bottom: 50px;
    .my_collage_wrap {
      font-size: 27px;
    }
    .couter_wrap {
      width: 600px;
      padding: 8px 40px;
      li {
        padding: 19px 0;
        i {
          width: 45px;
          margin-right: 15px;
          font-size: 24px;
        }
        .collage {
          font-size: 35px;
          line-height: 35px;
        }
        .score {
          font-size: 28px;
          line-height: 28px;
        }
      }
    }
    .count_user_box {
      .user_check {
        width: 400px;
        .txt {
          margin-bottom: 20px;
          font-size: 26px;
          line-height: 32px;
        }
        .apply {
          width: 252px;
          padding: 10px 14px;
          font-size: 26px;
          line-height: 39px;
        }
      }
      .info {
        font-size: 21px;
        span {
          font-size: 14px;
        }
      }
    }
  }
  .content3 {
    padding: 100px 0;
    .cont3_txt {
      div {
        font-size: 35px;
        p {
          span {
            font-size: 31px;
            line-height: 31px;
          }
        }
      }
    }
    .step01,
    .step02 {
      width: 220px;
    }
    .step01 {
      margin: 60px 0 20px;
    }
    .step02 {
      margin-bottom: 20px;
    }
    .or {
      font-size: 28px;
      line-height: 28px;
    }
    .join_go {
      width: 300px;
    }
    .book_go {
      width: 300px;
    }
  }
  .content4 {
    padding: 40px 0 40px;
    .benefit_list {
      span {
        font-size: 27px;
        line-height: 27px;
      }
      .beneforth {
        img {
          width: 398px;
        }
      }
    }
  }
  .content5 {
    padding: 40px 0 40px 0;
    > div {
      font-size: 28px;
      line-height: 28px;
    }
    .share_wrap {
      li {
        font-size: 18px;
        img {
          width: 135px;
        }
      }
    }
  }
}
@media (max-width: 480px) {
  //apply
  .inner {
    max-width: 350px;
  }
  .caution_wrap {
    padding: 35px 0 10px;
    &.user_cause {
      .slide_list {
        width: 347px;
        margin-top: 35px;
      }
    }
    .txt {
      margin-bottom: 22px;
      padding-left: 42px;
      font-size: 20px;
      line-height: 20px;
    }
    .slide_list {
      width: 360px;
      font-size: 16px;
      li {
        font-size: 16px;
      }
      .cau_wrap1 {
        line-height: 36px;
        ul {
          li {
            line-height: 32px;
          }
        }
        h2 {
          font-size: 25px;
          margin: 20px 0 20px;
        }
      }
    }
  }
  .select_wrap {
    li {
      padding: 18px 0;
      font-size: 16px;
      &:nth-child(2) {
        padding: 27px 0;
      }
      &:last-child {
        padding: 27px 0;
      }
    }
  }
  //cont
  .content1 {
    .txt_wrap {
      top: 40px;
      left: 30px;
      h2 {
        font-size: 43px;
        line-height: 46px;
        margin-bottom: 14px;
      }
      span {
        font-size: 19px;
        line-height: 24px;
      }
    }
  }
  .content2 {
    // height: 114vh;
    height: 990px;
    padding-top: 40px;
    // padding-bottom: 40px;
    .my_collage_wrap {
      font-size: 16px;
    }
    .count_user_box {
      .user_check {
        width: 304px;
        .non_collage {
          padding: 35px 25px 25px;
        }
        .txt {
          font-size: 19px;
          line-height: 23px;
        }
        .apply {
          width: 160px;
          font-size: 20px;
          line-height: 28px;
        }
      }
      .info {
        font-size: 13px;
        span {
          font-size: 12px;
        }
      }
    }
    .couter_wrap {
      width: 330px;
      padding: 12px 23px;
      li {
        margin-right: 9px;
        padding: 10px 0;
        font-size: initial;
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
          i {
            height: 40px;
          }
          .collage {
            font-size: 23px;
            line-height: 23px;
          }
        }
        &:nth-child(n + 4) {
          .collage {
            font-size: 17px;
            line-height: 17px;
          }
        }
        i {
          width: 32px;
          font-size: 17px;
        }
        .score {
          font-size: 17px;
          line-height: 17px;
        }
      }
    }
  }
  .content3 {
    padding: 0;
    .cont3_txt {
      > div {
        margin-top: 30px;
        font-size: 22px;
        p {
          span {
            font-size: 22px;
            line-height: 22px;
          }
        }
      }
    }
    .step01,
    .step02 {
      width: 135px;
    }
    .step01 {
      margin: 40px 0 10px;
    }
    .step02 {
      margin-bottom: 15px;
    }
    .or {
      margin: 17px 0 22px;
      font-size: 20px;
      line-height: 20px;
    }
    .join_go {
      width: 225px;
      margin: 35px auto 35px;
    }
    .book_go {
      width: 225px;
    }
  }
  .content4 {
    padding: 30px 0 30px;
    .cont4_txt {
      img {
        width: 215px;
      }
    }
    .benefit_list {
      .first,
      .second,
      .third {
        img {
          width: 66px;
        }
      }
      .fourth {
        img {
          width: 135px;
        }
      }
      .beneforth {
        img {
          width: 289px;
        }
      }
      span {
        font-size: 16px;
        line-height: 16px;
      }
    }
  }
  .content5 {
    padding: 30px 0 12px 0;
    > div {
      font-size: 19px;
      line-height: 19px;
    }
    .share_wrap {
      gap: 25px;
      li {
        font-size: 14px;
        img {
          width: 90px;
        }
      }
    }
  }
}
</style>
